import * as React from 'react';
import { State } from '~/store/types';
import connect from '~/store/connect';
import AlertTable from '~/components/AlertTable';
import { Alert as AlertComp, Button, Panel, Spinner } from '@ixicare/ui';
import { t } from '~/i18n';
import Alert from '~store/Alert/Alert';
import { ExportModal } from './AlertsExportModal';
import { exportAlerts } from './export-alerts';
import { LowBatteryDeviceTable } from './LowBatteryDeviceTable';
import { useLowBatteryDevices } from './utils';
import { SiteConfiguration } from '@ixicare/resources';

interface AlertTableContainerProps {
  alerts: Alert[];
  fetchAlerts: State['alerts']['fetchAlerts'];
  alertsLoading: boolean;
  getSiteConfig: () => Promise<SiteConfiguration>;
}

const AlertTableContainer: React.FC<AlertTableContainerProps> = ({
  alerts,
  fetchAlerts,
  alertsLoading,
  getSiteConfig,
}) => {
  React.useEffect(() => {
    fetchAlerts();
    getSiteConfig()
      .then((value) => {
        setSiteConfiguration(value['alarm-resolve-verification-mode']);
      })
      .catch((e) => console.log(e));
  }, []);

  const [siteConfiguration, setSiteConfiguration] = React.useState<any>('');

  const openAlerts = React.useMemo(() => alerts.filter((a) => a.isOpen), [alerts]);
  const acceptedAlerts = React.useMemo(() => alerts.filter((a) => a.isAcceptedOwnExcluded), [alerts]);
  const resolvedAlerts = React.useMemo(() => alerts.filter((a) => a.isResolved), [alerts]);

  const [showExportModal, setShowExportModal] = React.useState(false);

  const lowBatteryDevices = useLowBatteryDevices();

  if (alertsLoading) {
    return <Spinner label={t('global.loading')} />;
  }
  return (
    <>
      <Panel className="mb-25">
        <Panel.Title>{t('alert.status.needsResponse')}</Panel.Title>
        {openAlerts.length ? (
          <AlertTable alerts={openAlerts} />
        ) : (
          <AlertComp type="message">{t('alert.status.noAlerts.needsResponse')}</AlertComp>
        )}
      </Panel>

      <Panel className="mb-25">
        <Panel.Title>{t('alert.status.beingRespondedTo')}</Panel.Title>
        {acceptedAlerts.length ? (
          <AlertTable alerts={acceptedAlerts} />
        ) : (
          <AlertComp type="message">{t('alert.status.noAlerts.beingRespondedTo')}</AlertComp>
        )}
      </Panel>

      {lowBatteryDevices && lowBatteryDevices.length > 0 && (
        <Panel className="mb-25">
          <Panel.Title>{t('alert.status.lowBatterySection.title')}</Panel.Title>
          <LowBatteryDeviceTable devices={lowBatteryDevices} />
        </Panel>

        //"LowBatterySection":{"title":"Apparaten met laag percentage batterij"},
      )}

      <Panel>
        <Panel.Title style={{ display: 'flex', justifyContent: 'space-between' }}>
          {t('alert.status.resolvedAlerts')}
          <Button onClick={() => setShowExportModal(true)}>{'Export'}</Button>
        </Panel.Title>
        {resolvedAlerts.length ? (
          <AlertTable
            alerts={resolvedAlerts.slice(0, 25)}
            deviceVerification={siteConfiguration != 'none' ? true : false}
          />
        ) : (
          <AlertComp type="message">{t('alert.status.noAlerts.resolvedAlerts')}</AlertComp>
        )}
      </Panel>
      {showExportModal && <ExportModal exportHandler={exportAlerts} onClose={() => setShowExportModal(false)} />}
    </>
  );
};

export default connect((state: State) => ({
  alerts: state.alerts.alertsSorted,
  openAlerts: state.alerts.openAlerts,
  fetchAlerts: state.alerts.fetchAlerts,
  alertsLoading: state.alerts.isLoading,
}))(AlertTableContainer);
